module.exports = __webpack_public_path__ + "static/img/guest60.2be2174.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/guest60.png
// module id = 7IRF
// module chunks = 0